<template>
    <div class="ui-facilita-attendance">
        <section class="ui-facilita-attendance-register">
            <section class="ui-facilita-attendance-register-content">
                <ui-select-v2
                    v-model="form.historical.type"
                    placeholder="Tipo:"
                    item-label="label"
                    return-value="value"
                    :show-footer="false"
                    :data="historicalTypesOptions"
                    :loading="loader.historicalTypesLoad"
                    :search="false"
                />

                <ui-textarea
                    v-model="form.historical.message"
                    placeholder="Digite..."
                    rows="6"
                />
            </section>

            <section class="ui-facilita-attendance-register-footer">
                <ui-button
                    type="button"
                    design="md success mw-100"
                    :disabled="!canSubmit"
                    :loading="loader.loadSaveButton"
                    @click="submit"
                >
                    Salvar
                </ui-button>
            </section>
        </section>

        <div v-if="loader.loadSave && !loader.hasRegister" class="loading-card">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
        </div>

        <register-tasks-card
            v-for="(card, index) in cardAttendance.historical"
            v-else
            :key="card.id"
            disable-flag
            :load-new-card="loader.loadNewCard"
            :menu-options="menuOptions"
            :data="card"
            :index="index"
            :show-date="isYearChanged(index)"
            @delete-card="handleDeleteCard"
        />

        <div v-if="cardAttendance.historical.length == 0 && !loader.loadSave" class="no-data">
            Nenhum atendimento cadastrado!
        </div>

        <div v-if="!hasMore && cardAttendance.pagination.total > 15" class="button-attendance">
            <ui-button
                design="primary md"
                :loading="loader.hasRegister"
                @click="hasMoreAttendance"
            >
                Carregar Mais
            </ui-button>
        </div>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2, uiTextarea } from '@/components/ui/form'
	import { alertMixin, loaderMixin, utilMixin } from '@/mixins'
	import { task } from '@/services/axios'
	import { mapActions, mapGetters } from 'vuex'
	import registerTasksCard from '../register-tasks-card'
	import { defaultGtm } from './default'

	const moment = require('moment')

	require('moment/locale/pt-br')

	const defaultHistoricalData = {
		message: null,
		type: null,
	}

	const defaultLoader = {
		historicalTypesLoad: false,
		loadSave: false,
		hasRegister: false,
		loadSaveButton: false,
		loadNewCard: false
	}

	export default {
		name: 'ui-contracts-create-historical',

		components: {
			uiSelectV2,
			uiButton,
			uiTextarea,
			registerTasksCard,
			uiLoadIndicator
		},

		mixins: [loaderMixin, alertMixin, utilMixin],

		data() {
			return {
				form: {
					historical: { ...defaultHistoricalData },
				},
				loader: { ...defaultLoader },
				historicalTypesOptions: [],
				gtm: { ...defaultGtm() },
				menuOptions: [
					{
						active: true,
						label: 'Excluir'
					}
				]
			}
		},

		computed: {
			...mapGetters('contractAttendanceTasks', {
				getDealId: 'getDealId',
				cardAttendance: 'getHistorical'
			}),

			hasAHistorical() {
				return this.form.historical.message && this.$mx_hasValue(this.form.historical.type)
			},

			canSubmit() {
				return (
					this.hasAHistorical
				)
			},

			hasMore() {
				return (this.cardAttendance.pagination.current_page == this.cardAttendance.pagination.last_page)
			},

			validateFormHistoricalData() {
				const type = this.form.historical.type
				if (this.$mx_hasValue(type))
					return {
						subject: 'Registro de Atendimento: ' + this.historicalTypeTitle(type),
						type: type,
						message: this.form.historical.message,
						deal_id: this.getDealId,
					}
				else return null
			}
		},

		async mounted() {
			this.reset()

			await this.historicalTypesHandler()

			if (this.cardAttendance.historical.length == 0) {
				await this.handleDataCards(1)
			}
		},

		methods: {
			...mapActions('contractAttendanceTasks', [
				'getHistoricalCards',
				'createDealHistorical',
				'deleteDealHistorical'
			]),

			async handleDeleteCard(id) {
				try {
					await this.deleteDealHistorical(id)
				} catch(error) {
					this.$mx_alertThisOnError(error)
				}
			},

			async handleDataCards(page) {
				this.loader.loadSave = true

				try {
					await this.getHistoricalCards(page)
					this.loader.loadSave = false
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.loadSave  = false
				}
			},

			async hasMoreAttendance() {
				if (this.cardAttendance.pagination.page <= this.cardAttendance.pagination.last_page) {
					this.loader.hasRegister = true
					await this.handleDataCards(this.cardAttendance.pagination.page)
					this.loader.hasRegister = false
				}
			},

			async getHistoricalTypes() {
				try {
					const types = await task.getAll('types', null)
					return [...types.data[0].fields]
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			async historicalTypesHandler() {
				if (!this.historicalTypesOptions.length) {
					this.$mx_setLoader('historicalTypesLoad', true)
					this.historicalTypesOptions = await this.getHistoricalTypes()
					this.$mx_setLoader('historicalTypesLoad', false)
				}
			},

			historicalTypeTitle(type) {
				return this.historicalTypesOptions.find((his) => his.value == type).label
			},

			isYearChanged(currentIndex) {
				if (currentIndex === 0) return true

				const currentYear = moment(this.cardAttendance[currentIndex]?.historical.created_at).year()
				const previousYear = moment(this.cardAttendance[currentIndex - 1]?.historical.created_at).year()

				return currentYear !== previousYear
			},

			reset() {
				this.form.historical = { ...defaultHistoricalData }
				this.loader = { ...defaultLoader }
			},

			async submit() {
				if (!this.canSubmit) return
				this.loader.loadSaveButton = true
				this.loader.loadNewCard = true

				try {
					await this.createDealHistorical(this.validateFormHistoricalData)
					this.$gtm.trackEvent(this.gtm.submit)
					this.reset()
					this.loader.loadSaveButton = false
					this.loader.loadNewCard = false
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.reset()
					this.loader.loadSaveButton = false
					this.loader.loadNewCard = false
				}
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
